import { useQuery, useQueryClient } from 'react-query'
import QUERIES from 'api/queries'
import { getAnalyzeResults, getAnalyzeStatus, getRecalculations, getReportBySlug, getReports } from './services'

export const useAnalyzeResults = (taxYear: number) =>
	useQuery([QUERIES.analyzeResults, taxYear], () => getAnalyzeResults(taxYear))

export const useAnalyzeStatus = () => {
	const queryClient = useQueryClient()

	return useQuery(QUERIES.analyzeStatus, getAnalyzeStatus, {
		onSuccess: ({ progress }) => {
			if (progress === 1) {
				// update allowed tax analysis run
				queryClient.invalidateQueries([QUERIES.current])
			}
		},
	})
}

export const useReports = (taxYear: number) => useQuery([QUERIES.reports, taxYear], () => getReports(taxYear))

export const useReportBySlug = (slug: string, taxYear: number) =>
	useQuery([QUERIES.reportBySlug, slug, taxYear], () => getReportBySlug(slug, taxYear))

export const useRecalculations = () => useQuery(QUERIES.recalculations, getRecalculations)
